module.exports = __webpack_public_path__ + "media/images/icons/icon_sort_primary-f3a9c284af4f3792c292282ad0050d49.svg";